export type NavCapability = 'canManageOrg' | 'canManageRestaurant' | 'canManageRestaurantSettings';

export interface SettingsNavItem {
  path: string;
  labelKey: string;
  /** Shown only while billing is on (Polar configured); self-hosted copies never see it. */
  billingOnly?: boolean;
}

export interface SettingsNavSection {
  key: string;
  labelKey: string;
  capability: NavCapability;
  items: SettingsNavItem[];
}

export const SETTINGS_ROOT = '/settings';

export const settingsNav: SettingsNavSection[] = [
  {
    key: 'organization',
    labelKey: 'settingsNav.organization.title',
    capability: 'canManageOrg',
    items: [
      { path: '/settings/organization', labelKey: 'settingsNav.organization.general' },
      { path: '/settings/organization/members', labelKey: 'settingsNav.organization.members' },
      { path: '/settings/organization/invitations', labelKey: 'settingsNav.organization.invitations' },
      { path: '/settings/organization/audit', labelKey: 'settingsNav.organization.audit' },
      { path: '/settings/organization/billing', labelKey: 'settingsNav.organization.billing', billingOnly: true },
    ],
  },
  {
    key: 'restaurant',
    labelKey: 'settingsNav.restaurant.title',
    capability: 'canManageRestaurantSettings',
    items: [
      { path: '/settings/restaurant', labelKey: 'settingsNav.restaurant.information' },
      { path: '/settings/restaurant/branches', labelKey: 'settingsNav.restaurant.branches' },
      { path: '/settings/restaurant/tables', labelKey: 'settingsNav.restaurant.tables' },
      { path: '/settings/restaurant/timesheets', labelKey: 'settingsNav.restaurant.timesheets' },
    ],
  },
  {
    key: 'menu',
    labelKey: 'settingsNav.menu.title',
    capability: 'canManageRestaurantSettings',
    items: [
      { path: '/settings/menu', labelKey: 'settingsNav.menu.menu' },
      { path: '/settings/menu/items', labelKey: 'settingsNav.menu.items' },
      { path: '/settings/menu/item-variants', labelKey: 'settingsNav.menu.itemVariants' },
    ],
  },
  {
    key: 'accounting',
    labelKey: 'settingsNav.accounting.title',
    capability: 'canManageRestaurantSettings',
    items: [{ path: '/settings/accounting/categories', labelKey: 'settingsNav.accounting.categories' }],
  },
  {
    key: 'employees',
    labelKey: 'settingsNav.employees.title',
    capability: 'canManageRestaurantSettings',
    items: [
      { path: '/settings/employees/rules', labelKey: 'settingsNav.employees.rules' },
      { path: '/settings/employees/day-off', labelKey: 'settingsNav.employees.dayOff' },
    ],
  },
  {
    key: 'integrations',
    labelKey: 'settingsNav.integrations.title',
    capability: 'canManageOrg',
    items: [
      { path: '/settings/integrations', labelKey: 'settingsNav.integrations.title' },
      { path: '/settings/integrations/zalo', labelKey: 'settingsNav.integrations.zalo' },
    ],
  },
];
